import { message, Modal, Select, Switch } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  SelectItem,
  TextAreaItem,
  ErrorItem,
} from "../../../../Components/Items";

const { Option } = Select;

class EscuelaModal extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    objetoTiposCliente: [],
    tipoDeClienteOriginal: null,
    empresaPrecios: [],
    listaPrecioOriginal: null,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      if (this.formRef.current) {
        this.formRef.current.resetFields();
      }
      this.setState({ tipoDeClienteOriginal: null, listaPrecioOriginal: null });
      this.consultarTiposCliente();
      this.consultarPrecios();
      if (this.props.escuela?._id) {
        this.consultarDatosEscuela(this.props.escuela._id);
      }
    }
  }

  esEdicion = () => Boolean(this.props.escuela?._id);

  consultarTiposCliente = () => {
    axios
      .post(
        "tiposdeclientes/selectTiposDeClientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        const lista = Array.isArray(res.data) ? res.data : [];
        this.setState({
          objetoTiposCliente: lista.map((value) => (
            <Option value={value._id} key={value._id}>
              {value.nombre}
            </Option>
          )),
        });
      })
      .catch(() => {});
  };

  consultarDatosEscuela(id) {
    this.setState({ loading: true });
    axios
      .post(
        "escuelas/datosEscuela",
        { escuelaId: id },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2 && res.data.escuela) {
          const {
            nombre,
            descripcion,
            clave,
            tipoDeClienteId,
            listaPrecioId,
            leyenda,
            envioListaLibrosDiaria,
          } = res.data.escuela;
          this.setState({
            tipoDeClienteOriginal: tipoDeClienteId || null,
            listaPrecioOriginal: listaPrecioId || null,
          });
          this.formRef.current.setFieldsValue({
            nombre,
            descripcion,
            clave,
            tipoDeClienteId,
            listaPrecioId,
            leyenda,
            envioListaLibrosDiaria: {
              activo: Boolean(envioListaLibrosDiaria?.activo),
              correosEnvio: envioListaLibrosDiaria?.correosEnvio || [],
            },
          });
        } else {
          message.error("No se encontraron los datos de la escuela");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  onFinish = (values) => {
    if (!values?.nombre) {
      message.info("Proporcione al menos el nombre de la escuela");
      return;
    }
    if (!values?.tipoDeClienteId) {
      message.info("Selecciona un tipo de cliente");
      return;
    }

    const cambioListaPrecio =
      this.esEdicion() &&
      String(values.listaPrecioId || "") !== String(this.state.listaPrecioOriginal || "");

    if (cambioListaPrecio) {
      Modal.confirm({
        title: "Se actualizará la lista de precios",
        content: "Se actualizará la lista de precios del P. E-Commerce a TODOS los alumnos de esta escuela. ¿Deseas continuar?",
        okText: "Sí, actualizar",
        cancelText: "Cancelar",
        onOk: () => this.guardar(values),
      });
      return;
    }

    this.guardar(values);
  };

  guardar = (values) => {
    this.setState({ loading: true });

    const url = this.esEdicion()
      ? "escuelas/editarEscuela"
      : "escuelas/agregarEscuela";

    const payload = this.esEdicion()
      ? { ...values, escuelaId: this.props.escuela._id }
      : { ...values, empresaId: this.props.empresaId };

    axios
      .post(url, payload, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            this.esEdicion()
              ? "Escuela actualizada exitosamente"
              : "Escuela agregada exitosamente",
          );
          const actualizados = res.data.alumnosActualizados || 0;
          if (actualizados > 0) {
            message.info(
              `Se actualizó el P. E-Commerce de ${actualizados} alumno${
                actualizados === 1 ? "" : "s"
              }`,
            );
          }
          this.cerrarModal(true);
        } else {
          message.error(
            this.esEdicion()
              ? "No se pudo actualizar la escuela"
              : "No se pudo agregar la escuela",
          );
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  };

  onFinishFailed = (e) => {
    ErrorItem(e);
  };

  cerrarModal = (recargar = false) => {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.props.cerrarModal(recargar);
  };

  consultarPrecios = () => {
    this.setState({ loading: true });
    axios
      .post(
        "empresas/selectPrecios",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.status === 200) {
          this.setState({ empresaPrecios: res.data, loading: false }); 
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Error al obtener los precios");
      });
  };

  render() {
    return (
      <ModalItem
        title={this.esEdicion() ? "Editar Escuela" : "Agregar Escuela"}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrarModal(false)}
        width={600}
      >
        <Form
          ref={this.formRef}
          name="modalEscuela"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              className="botonAgregar"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem name="clave" label="Clave" margin>
            <InputItem placeholder="Ingresa la clave" />
          </FormItem>

          <FormItem name="nombre" label="Nombre" required margin>
            <InputItem placeholder="Ingresa el nombre de la escuela" />
          </FormItem>

          <FormItem name="descripcion" label="Descripción" margin>
            <InputItem placeholder="Ingresa una breve descripción" />
          </FormItem>

          <FormItem
            name="tipoDeClienteId"
            label="Tipo de Cliente"
            margin
            required
            tooltip="Tipo de cliente por defecto que se pondrá al agregar un alumno de esta escuela."
          >
            <SelectItem placeholder="Selecciona un tipo de cliente">
              {this.state.objetoTiposCliente}
            </SelectItem>
          </FormItem>
          <FormItem
            name="listaPrecioId"
            label="Lista de precios"
            margin
            tooltip="Esta lista de precios se sobrepondrá a la lista general del e-commerce para los alumnos de esta escuela."
          >
            <SelectItem placeholder="Selecciona una lista de precios" allowClear>
              {this.state.empresaPrecios.map((p) => (
                <Option key={String(p._id)} value={String(p._id)}>
                  {p.nombre}
                </Option>
              ))}
            </SelectItem>
          </FormItem>

          <FormItem
            name="leyenda"
            label="Leyenda"
            margin
            tooltip="Esta leyenda saldra en los paquetes a comprar"
          >
            <TextAreaItem placeholder="Ingresa la leyenda" />
          </FormItem>

          <FormItem
            name={["envioListaLibrosDiaria", "activo"]}
            label="Enviar lista diaria de libros asignados"
            margin
            valuePropName="checked"
            tooltip="Cada madrugada se envía un PDF con los alumnos de la escuela a los que se les asignó la clave de su libro el día anterior."
            wrapperLabel={{ span: 6 }}
            labelCol={{ span: 18 }}
          >
            <Switch />
          </FormItem>

          <FormItem
            shouldUpdate={(prev, curr) =>
              prev.envioListaLibrosDiaria?.activo !==
              curr.envioListaLibrosDiaria?.activo
            }
            noStyle
          >
            {({ getFieldValue }) =>
              getFieldValue(["envioListaLibrosDiaria", "activo"]) ? (
                <FormItem
                  name={["envioListaLibrosDiaria", "correosEnvio"]}
                  label="Correos destinatarios"
                  margin
                  tooltip="Escribe un correo y presiona Enter para agregarlo"
                >
                  <SelectItem
                    mode="tags"
                    placeholder="correo@ejemplo.com"
                    style={{ width: "100%" }}
                  />
                </FormItem>
              ) : null
            }
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EscuelaModal);
